// J.R. Jones Racing LLC tune builder map.
// Loaded by every live year/make/model/engine builder in the theme.
// Custom-tune handles and fallback prices mirror the Shopify pricing matrix.

window.JRJ_TUNE_BUILDER_DRAFT = {
  baseProducts: {
    gen3_gm_truck_suv: {
      title: "Gen III GM Truck & SUV Custom Tune",
      handle: "gen-iii-gm-truck-suv-custom-tune",
      url: "https://jrjonesracing.com/products/gen-iii-gm-truck-suv-custom-tune",
      legacyHandles: ["1998-2006-silverado-sierra-chopacabra-cam-performance-tune-hp-tuners"],
      price: 269.99,
      requiresExactCamRoute: true
    },
    gen3_gm_car: {
      title: "Gen III GM Car Custom Tune",
      handle: "gen-iii-gm-car-custom-tune",
      url: "https://jrjonesracing.com/products/gen-iii-gm-car-custom-tune",
      price: 299.99
    },
    gen4_gm_truck_suv: {
      title: "Gen IV GM Truck & SUV Custom Tune",
      handle: "gen-iv-gm-truck-suv-custom-tune",
      url: "https://jrjonesracing.com/products/gen-iv-gm-truck-suv-custom-tune",
      legacyHandles: ["2007-2013-silverado-5-3l-stock-tune-chopacabra-cam-tune-truck-norris-tune-file-hp-tuners-efi-live"],
      price: 289.99,
      requiresExactCamRoute: true
    },
    gen4_gm_car: {
      title: "Gen IV GM Car Custom Tune",
      handle: "gen-iv-gm-car-custom-tune",
      url: "https://jrjonesracing.com/products/gen-iv-gm-car-custom-tune",
      price: 339.99
    },
    gen5_gm_truck_suv: {
      title: "Gen V GM Truck & SUV Custom Tune",
      handle: "gen-v-gm-truck-suv-custom-tune",
      url: "https://jrjonesracing.com/products/gen-v-gm-truck-suv-custom-tune",
      legacyHandles: ["2014-2018-gm-ls-tune-file-4-8-5-3-6-2l"],
      price: 329.99,
      requiresExactCamRoute: true
    },
    gen5_gm_car: {
      title: "Gen V GM Car Custom Tune",
      handle: "gen-v-gm-car-custom-tune",
      url: "https://jrjonesracing.com/products/gen-v-gm-car-custom-tune",
      price: 379.99
    },
    hemi_ram_2009_2012: {
      title: "2009-2012 RAM HEMI Truck Custom Tune",
      handle: "2009-2012-ram-hemi-truck-custom-tune",
      url: "https://jrjonesracing.com/products/2009-2012-ram-hemi-truck-custom-tune",
      legacyHandles: ["2009-2012-dodge-ram-hemi-tune-files-hp-tuners"],
      price: 309.99,
      requiresExactCamRoute: true
    },
    hemi_car_2009_2014: {
      title: "2009-2014 HEMI Car Custom Tune",
      handle: "2009-2014-hemi-car-custom-tune",
      url: "https://jrjonesracing.com/products/2009-2014-hemi-car-custom-tune",
      price: 339.99
    },
    hemi_ram_2013_2018: {
      title: "2013-2018 RAM HEMI Truck Custom Tune",
      handle: "2013-2018-ram-hemi-truck-custom-tune",
      url: "https://jrjonesracing.com/products/2013-2018-ram-hemi-truck-custom-tune",
      legacyHandles: ["2013-2018-ram-hemi-performance-tune-files-btr-truck-norris-tsp-chopacabra"],
      price: 329.99,
      requiresExactCamRoute: true
    },
    hemi_car_2015_2023: {
      title: "2015-2023 HEMI Car Custom Tune",
      handle: "2015-2023-hemi-car-custom-tune",
      url: "https://jrjonesracing.com/products/2015-2023-hemi-car-custom-tune",
      price: 359.99
    },
    hemi_ram_2019_2022: {
      title: "2019-2022 RAM HEMI Truck Custom Tune",
      handle: "2019-2022-ram-hemi-truck-custom-tune",
      url: "https://jrjonesracing.com/products/2019-2022-ram-hemi-truck-custom-tune",
      legacyHandles: ["2019-up-ram-hemi-performance-tune-files-btr-truck-norris-tsp-chopacabra"],
      price: 369.99,
      requiresExactCamRoute: true
    }
  },

  // Engine architecture is the source of truth for tune and add-on routing.
  // Year/make/model only control which engine choices the builder offers.
  engineApplications: {
    gm: {
      gen3: {
        key: "gm_gen3",
        codes: ["LR4", "LM7", "L59", "LM4", "L33", "LQ4", "LQ9", "LS1", "LS6"],
        modFamily: "standard"
      },
      gen4: {
        key: "gm_gen4",
        codes: ["LS2", "LS4", "LY2", "L20", "LH6", "LY5", "LMG", "LC9", "LH8", "LH9", "LY6", "L96", "LC8", "L76", "L77", "LFA", "LZ1", "L92", "L9H", "L94", "LS3", "L99", "LSA", "LS7", "LS9"],
        modFamily: "standard"
      },
      gen5: {
        key: "gm_gen5",
        codes: ["LV1", "LV3", "L83", "L86", "L82", "L84", "L87", "L8T", "LT1", "LT2", "LT4", "LT5"],
        modFamily: "gen_v"
      }
    },
    hemi: {
      hemi_57_vvt: { key: "hemi_57_vvt", match: "5.7", camOptionsKey: "HEMI 5.7 VVT", modFamily: "standard" },
      hemi_61_non_vvt: { key: "hemi_61_non_vvt", match: "6.1", camOptionsKey: "HEMI 6.1 NON-VVT", modFamily: "standard" },
      hemi_64_hd_bge: { key: "hemi_64_hd_bge", match: "6.4.*BGE|BGE.*6.4", camOptionsKey: "HEMI 6.4 HD BGE", modFamily: "standard" },
      hemi_64_vvt: { key: "hemi_64_vvt", match: "6.4|392", camOptionsKey: "HEMI 6.4 VVT", modFamily: "standard" },
      hemi_62_hellcat: { key: "hemi_62_hellcat", match: "6.2|hellcat|trackhawk|demon|redeye|trx", camOptionsKey: "HEMI 6.2 HELLCAT", modFamily: "standard" }
    }
  },

  addons: {
    mpvi4: {
      title: "Tune Add-Ons - MPVI4",
      handle: "mpvi4",
      url: "https://jrjonesracing.com/products/mpvi4",
      price: 419.99
    },
    rush_turnaround: {
      title: "Tune Add-On: Rush Turnaround",
      handle: "tune-add-on-rush-turnaround",
      url: "https://jrjonesracing.com/products/tune-add-on-rush-turnaround",
      price: 99.99
    },
    long_tube_headers_ypipe_xpipe: {
      title: "Tune Add-On: Long Tube Headers + Y-Pipe/X-Pipe",
      handle: "tune-add-on-long-tube-headers-y-pipe-x-pipe",
      url: "https://jrjonesracing.com/products/tune-add-on-long-tube-headers-y-pipe-x-pipe",
      price: 20.99,
      genVHandle: "tune-add-on-long-tube-headers-y-pipe-x-pipe-gen-v",
      genVPrice: 34.99
    },
    cold_air_intake: {
      title: "DOD / MDS Cold Air Intake Tune Add-On",
      handle: "dod-mds-cold-air-intake-tune-add-on",
      url: "https://jrjonesracing.com/products/dod-mds-cold-air-intake-tune-add-on",
      price: 9.99
    },
    throttle_body: {
      title: "Tune Add-On: Throttle Body Upgrade",
      handle: "tune-add-on-throttle-body-upgrade",
      url: "https://jrjonesracing.com/products/tune-add-on-throttle-body-upgrade",
      price: 14.99,
      genVHandle: "tune-add-on-throttle-body-upgrade-gen-v",
      genVPrice: 24.99
    },
    injectors: {
      title: "Tune Add-On: Upgraded Injectors",
      handle: "tune-add-on-upgraded-injectors",
      url: "https://jrjonesracing.com/products/tune-add-on-upgraded-injectors",
      price: 20.99,
      genVHandle: "tune-add-on-upgraded-injectors-gen-v",
      genVPrice: 34.99
    },
    gear_ratio: {
      title: "Tune Add-On: Gear Ratio Change",
      handle: "tune-add-on-gear-ratio-tire-size-change",
      url: "https://jrjonesracing.com/products/tune-add-on-gear-ratio-tire-size-change",
      price: 8.99
    },
    tire_size: {
      title: "Tune Add-On: Tire Size Change",
      handle: "tune-add-on-tire-size-change",
      url: "https://jrjonesracing.com/products/tune-add-on-tire-size-change",
      price: 8.99
    },
    transmission_tune: {
      title: "Tune Add-On: Transmission Tune",
      handle: "tune-add-on-transmission-tune",
      url: "https://jrjonesracing.com/products/tune-add-on-transmission-tune",
      price: 24.99,
      genVHandle: "tune-add-on-transmission-tune-gen-v",
      genVPrice: 44.99
    },
    intake_manifold: {
      title: "Tune Add-On: Upgraded Intake Manifold",
      handle: "tune-add-on-upgraded-intake-manifold",
      url: "https://jrjonesracing.com/products/tune-add-on-upgraded-intake-manifold",
      price: 20.99,
      genVHandle: "tune-add-on-upgraded-intake-manifold-gen-v",
      genVPrice: 34.99
    },
    ported_heads: {
      title: "Tune Add-On: Aftermarket / Ported Heads",
      handle: "tune-add-on-aftermarket-ported-heads",
      url: "https://jrjonesracing.com/products/tune-add-on-aftermarket-ported-heads",
      price: 14.99,
      genVHandle: "gen-v-tune-add-on-aftermarket-ported-heads",
      genVPrice: 34.99
    },
    torque_converter: {
      title: "Tune Add-On: Aftermarket Torque Converter",
      handle: "tune-add-on-aftermarket-torque-converter",
      url: "https://jrjonesracing.com/products/tune-add-on-aftermarket-torque-converter",
      price: 24.99,
      genVHandle: "gen-v-tune-add-on-aftermarket-torque-converter",
      genVPrice: 44.99
    },
    lsa_blower: {
      title: "Tune Add On: LSA Blower",
      handle: "tune-add-on-lsa-blower",
      url: "https://jrjonesracing.com/products/tune-add-on-lsa-blower",
      price: 254.99
    },
    hellcat_blower: {
      title: "Tune Add On: Hellcat Blower",
      handle: "tune-add-on-hellcat-blower",
      url: "https://jrjonesracing.com/products/tune-add-on-hellcat-blower",
      price: 254.99
    },
    stage_2_cam: {
      title: "Tune Add-On: Stage 2 Cam",
      handle: "tune-add-on-stage-2-cam",
      url: "https://jrjonesracing.com/products/tune-add-on-stage-2-cam",
      price: 34.99
    },
    stage_3_cam: {
      title: "Tune Add-On: Stage 3 Cam",
      handle: "tune-add-on-stage-3-cam",
      url: "https://jrjonesracing.com/products/tune-add-on-stage-3-cam",
      price: 44.99
    },
    stage_4_cam: {
      title: "Tune Add-On: Stage 4 Cam",
      handle: "tune-add-on-stage-4-cam",
      url: "https://jrjonesracing.com/products/tune-add-on-stage-4-cam",
      price: 54.99
    },
    gen_v_stage_2_cam: {
      title: "GEN V Tune Add-On: Stage 2 Cam",
      handle: "gen-v-tune-add-on-stage-2-cam",
      url: "https://jrjonesracing.com/products/gen-v-tune-add-on-stage-2-cam",
      price: 54.99
    },
    gen_v_stage_3_cam: {
      title: "GEN V Tune Add-On: Stage 3 Cam",
      handle: "gen-v-tune-add-on-stage-3-cam",
      url: "https://jrjonesracing.com/products/gen-v-tune-add-on-stage-3-cam",
      price: 74.99
    },
    gen_v_stage_4_cam: {
      title: "GEN V Tune Add-On: Stage 4 Cam",
      handle: "gen-v-tune-add-on-stage-4-cam",
      url: "https://jrjonesracing.com/products/gen-v-tune-add-on-stage-4-cam",
      price: 74.99
    }
  },

  camRules: {
    included: [
      "Stock Cam",
      "Stage 1 Cam",
      "Texas Speed Chopacabra",
      "Texas Speed Chopacabra HEMI",
      "Texas Speed Chopacabra (Gen V)",
      "Texas Speed Chopacabra LS3",
      "Texas Speed NSR Chopacabra",
      "TSP Chopacabra 5.7L HEMI",
      "TSP 6.2L Chopacabra Cam",
      "TSP NSR 6.2L Chopacabra Cam",
      "TSP Gen V Chopacabra Truck Cam",
      "BTR Truck Norris",
      "BTR Truck Norris NSR",
      "BTR Truck Norris (Gen V)",
      "BTR Truck Norris LS3",
      "BTR Gen V 5.3L Truck Norris Cam"
    ],
    paid: {
      "Stage 2 Cam": "stage_2_cam",
      "Stage 3 Cam": "stage_3_cam",
      "Stage 4 Cam": "stage_4_cam"
    },
    quoteRequired: [
      "Custom Cam Specs / Not Listed"
    ]
  },

  addonRules: {
    "Long Tube Headers": "long_tube_headers_ypipe_xpipe",
    "Y-Pipe / X-Pipe": "long_tube_headers_ypipe_xpipe",
    "Cold Air Intake": "cold_air_intake",
    "Upgraded Intake Manifold": "intake_manifold",
    "Aftermarket Intake Manifold": "intake_manifold",
    "Throttle Body Upgrade": "throttle_body",
    "Upgraded Injectors": "injectors",
    "Aftermarket Injectors": "injectors",
    "Aftermarket / Ported Heads": "ported_heads",
    "Ported Heads": "ported_heads",
    "Aftermarket Torque Converter": "torque_converter",
    "Gear Ratio Change": "gear_ratio",
    "Tire Size Change": "tire_size",
    "Transmission Tune": "transmission_tune",
    "Rush Turnaround": "rush_turnaround",
    "Faster Turnaround": "rush_turnaround",
    "LSA Blower": "lsa_blower",
    "Hellcat Blower": "hellcat_blower",
    "HP Tuners MPVI4": "mpvi4"
  },

  includedDeletes: [
    "MDS Delete",
    "DOD / AFM Delete",
    "VVT Delete",
    "VVT Lockout"
  ],

  groups: [
    {
      id: "gen3_gm_truck_suv",
      label: "1998-2006 GM Truck & SUV / 2007 Classic",
      years: "1998-2009",
      baseProductKey: "gen3_gm_truck_suv",
      makes: {
        Chevrolet: [
          "Silverado",
          "Tahoe",
          "Suburban",
          "Avalanche",
          "TrailBlazer",
          "TrailBlazer SS",
          "SSR",
          "Express"
        ],
        GMC: ["Sierra", "Yukon", "Yukon XL", "Envoy", "Savana"],
        Cadillac: ["Escalade", "Escalade EXT", "Escalade ESV"],
        Hummer: ["H2"],
        Buick: ["Rainier"],
        Isuzu: ["Ascender"],
        Saab: ["9-7X"]
      },
      modelYears: {
        Chevrolet: { Silverado: "1999-2007", Tahoe: "2000-2006", Suburban: "2000-2006", Avalanche: "2002-2006", TrailBlazer: "2003-2006", "TrailBlazer SS": "2006-2007", SSR: "2003-2006", Express: "2003-2006" },
        GMC: { Sierra: "1999-2007", Yukon: "2000-2006", "Yukon XL": "2000-2006", Envoy: "2003-2006", Savana: "2003-2006" },
        Cadillac: { Escalade: "2002-2006", "Escalade EXT": "2002-2006", "Escalade ESV": "2003-2006" },
        Hummer: { H2: "2003-2007" },
        Buick: { Rainier: "2004-2006" },
        Isuzu: { Ascender: "2003-2006" },
        Saab: { "9-7X": "2005-2006" }
      },
      engineRules: [
        { engine: "4.8L LR4", years: "1999-2006", appliesTo: ["Chevrolet Silverado", "GMC Sierra", "Chevrolet Express", "GMC Savana"] },
        { engine: "5.3L LM7", years: "1999-2006", appliesTo: ["Chevrolet Silverado", "GMC Sierra", "Chevrolet Tahoe", "GMC Yukon", "Chevrolet Suburban", "GMC Yukon XL", "Chevrolet Avalanche", "Chevrolet TrailBlazer", "GMC Envoy", "Buick Rainier", "Isuzu Ascender", "Saab 9-7X", "Cadillac Escalade"] },
        { engine: "5.3L L59", years: "2002-2006", appliesTo: ["Chevrolet Silverado", "GMC Sierra", "Chevrolet Tahoe", "GMC Yukon", "Chevrolet Suburban", "GMC Yukon XL", "Chevrolet Avalanche"] },
        { engine: "5.3L LM4", years: "2003-2004", appliesTo: ["Chevrolet TrailBlazer", "Chevrolet SSR", "GMC Envoy", "Buick Rainier", "Isuzu Ascender"] },
        { engine: "5.3L L33", years: "2005-2007", appliesTo: ["Chevrolet Silverado", "GMC Sierra"] },
        { engine: "6.0L LQ4", years: "1999-2007", appliesTo: ["Chevrolet Silverado", "GMC Sierra", "Chevrolet Express", "GMC Savana", "Chevrolet Suburban", "GMC Yukon XL", "Hummer H2"] },
        { engine: "6.0L LQ9", years: "2002-2007", appliesTo: ["Cadillac Escalade", "Cadillac Escalade EXT", "Cadillac Escalade ESV", "Chevrolet Silverado", "GMC Sierra"] },
        { engine: "6.0L LS2", years: "2005-2007", appliesTo: ["Chevrolet TrailBlazer SS", "Chevrolet SSR"] }
      ]
    },
    {
      id: "gen3_gm_car",
      label: "Gen III GM Car Platform",
      years: "1998-2007",
      baseProductKey: "gen3_gm_car",
      makes: {
        Chevrolet: ["Camaro", "Corvette", "Corvette Z06", "Monte Carlo SS", "Impala SS"],
        Pontiac: ["Firebird", "Trans Am", "GTO", "Grand Prix GXP"],
        Cadillac: ["CTS-V"],
        Holden: ["Commodore", "Monaro", "Caprice", "Statesman", "Ute"],
        HSV: ["Clubsport", "GTS", "Senator", "Maloo", "Coupe"]
      },
      modelYears: {
        Chevrolet: { Camaro: "1998-2002", Corvette: "1998-2007", "Corvette Z06": "2001-2004", "Monte Carlo SS": "2006-2007", "Impala SS": "2006-2009" },
        Pontiac: { Firebird: "1998-2002", "Trans Am": "1998-2002", GTO: "2004-2006", "Grand Prix GXP": "2005-2008" },
        Cadillac: { "CTS-V": "2004-2007" }
      },
      engineRules: [
        { engine: "5.3L LS4", years: "2005-2009", appliesTo: ["Chevrolet Impala SS", "Chevrolet Monte Carlo SS", "Pontiac Grand Prix GXP"] },
        { engine: "5.7L LS1", years: "1998-2004", appliesTo: ["Chevrolet Camaro", "Pontiac Firebird", "Pontiac Trans Am", "Chevrolet Corvette", "Pontiac GTO", "Holden Commodore", "Holden Monaro", "Holden Caprice", "Holden Statesman", "Holden Ute", "HSV Clubsport", "HSV GTS", "HSV Senator", "HSV Maloo", "HSV Coupe"] },
        { engine: "5.7L LS6", years: "2001-2005", appliesTo: ["Chevrolet Corvette Z06", "Cadillac CTS-V", "HSV Clubsport", "HSV GTS", "HSV Senator", "HSV Maloo", "HSV Coupe"] },
        { engine: "6.0L LS2", years: "2005-2007", appliesTo: ["Pontiac GTO", "Chevrolet Corvette", "Cadillac CTS-V", "Holden Commodore", "Holden Monaro", "Holden Caprice", "Holden Statesman", "Holden Ute", "HSV Clubsport", "HSV GTS", "HSV Senator", "HSV Maloo", "HSV Coupe"] }
      ]
    },
    {
      id: "gen4_gm_truck_suv",
      label: "Gen IV GM Truck & SUV Platform",
      years: "2007-2014",
      baseProductKey: "gen4_gm_truck_suv",
      makes: {
        Chevrolet: ["Silverado 1500", "Silverado 2500 HD", "Silverado 3500 HD", "Tahoe", "Tahoe Hybrid", "Suburban", "Avalanche", "Express", "TrailBlazer SS"],
        GMC: ["Sierra 1500", "Sierra 2500 HD", "Sierra 3500 HD", "Sierra Denali", "Yukon", "Yukon XL", "Yukon Denali", "Yukon Hybrid", "Savana"],
        Cadillac: ["Escalade", "Escalade EXT", "Escalade ESV"],
        Hummer: ["H2", "H3 Alpha"],
        Buick: ["Rainier"],
        Saab: ["9-7X", "9-7X Aero"]
      },
      modelYears: {
        Chevrolet: { "Silverado 1500": "2007-2013", "Silverado 2500 HD": "2007-2014", "Silverado 3500 HD": "2007-2014", Tahoe: "2007-2014", "Tahoe Hybrid": "2008-2013", Suburban: "2007-2014", Avalanche: "2007-2013", Express: "2007-2014", "TrailBlazer SS": "2007-2009" },
        GMC: { "Sierra 1500": "2007-2013", "Sierra 2500 HD": "2007-2014", "Sierra 3500 HD": "2007-2014", "Sierra Denali": "2007-2013", Yukon: "2007-2014", "Yukon XL": "2007-2014", "Yukon Denali": "2007-2014", "Yukon Hybrid": "2008-2013", Savana: "2007-2014" },
        Cadillac: { Escalade: "2007-2014", "Escalade EXT": "2007-2013", "Escalade ESV": "2007-2014" }, Hummer: { H2: "2008-2009", "H3 Alpha": "2008-2010" }, Buick: { Rainier: "2007" }, Saab: { "9-7X": "2007-2009", "9-7X Aero": "2008-2009" }
      },
      engineRules: [
        { engine: "4.8L LY2", years: "2007-2009", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500", "Chevrolet Express", "GMC Savana"] },
        { engine: "4.8L L20", years: "2010-2014", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500", "Chevrolet Express", "GMC Savana"] },
        { engine: "5.3L LH6", years: "2007-2009", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500", "Chevrolet Tahoe", "GMC Yukon", "Chevrolet Suburban", "GMC Yukon XL", "Chevrolet Avalanche", "Buick Rainier", "Saab 9-7X"] },
        { engine: "5.3L LY5", years: "2007-2009", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500", "Chevrolet Tahoe", "GMC Yukon", "Chevrolet Suburban", "GMC Yukon XL", "Chevrolet Avalanche"] },
        { engine: "5.3L LC9", years: "2007-2013", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500", "Chevrolet Tahoe", "GMC Yukon", "Chevrolet Suburban", "GMC Yukon XL", "Chevrolet Avalanche"] },
        { engine: "5.3L LMG", years: "2007-2014", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500", "Chevrolet Tahoe", "GMC Yukon", "Chevrolet Suburban", "GMC Yukon XL", "Chevrolet Avalanche"] },
        { engine: "5.3L LH8", years: "2008-2009", appliesTo: ["Hummer H3 Alpha"] },
        { engine: "5.3L LH9", years: "2010", appliesTo: ["Hummer H3 Alpha"] },
        { engine: "6.0L LY6", years: "2007-2009", appliesTo: ["Chevrolet Silverado 2500 HD", "Chevrolet Silverado 3500 HD", "GMC Sierra 2500 HD", "GMC Sierra 3500 HD", "Chevrolet Express", "GMC Savana", "Hummer H2"] },
        { engine: "6.0L L96", years: "2010-2014", appliesTo: ["Chevrolet Silverado 2500 HD", "Chevrolet Silverado 3500 HD", "GMC Sierra 2500 HD", "GMC Sierra 3500 HD", "Chevrolet Express", "GMC Savana"] },
        { engine: "6.0L LC8", years: "2011-2014", appliesTo: ["Chevrolet Silverado 2500 HD", "Chevrolet Silverado 3500 HD", "GMC Sierra 2500 HD", "GMC Sierra 3500 HD", "Chevrolet Express", "GMC Savana"] },
        { engine: "6.0L L76", years: "2007-2009", appliesTo: ["GMC Yukon Denali", "Cadillac Escalade", "Cadillac Escalade EXT", "Cadillac Escalade ESV", "Chevrolet Avalanche"] },
        { engine: "6.0L LFA", years: "2008-2009", appliesTo: ["Chevrolet Tahoe Hybrid", "GMC Yukon Hybrid"] },
        { engine: "6.0L LZ1", years: "2010-2013", appliesTo: ["Chevrolet Tahoe Hybrid", "GMC Yukon Hybrid"] },
        { engine: "6.2L L92", years: "2007-2008", appliesTo: ["Cadillac Escalade", "Cadillac Escalade EXT", "Cadillac Escalade ESV", "GMC Yukon Denali"] },
        { engine: "6.2L L9H", years: "2009-2013", appliesTo: ["Cadillac Escalade", "Cadillac Escalade EXT", "Cadillac Escalade ESV", "GMC Yukon Denali", "GMC Sierra Denali", "Chevrolet Silverado 1500"] },
        { engine: "6.2L L94", years: "2010-2014", appliesTo: ["Cadillac Escalade", "Cadillac Escalade EXT", "Cadillac Escalade ESV", "GMC Yukon Denali"] },
        { engine: "6.0L LS2", years: "2007-2009", appliesTo: ["Chevrolet TrailBlazer SS", "Saab 9-7X Aero"] }
      ]
    },
    {
      id: "gen4_gm_car",
      label: "Gen IV GM Car Platform",
      years: "2005-2017",
      baseProductKey: "gen4_gm_car",
      makes: {
        Chevrolet: ["Camaro SS", "Camaro ZL1", "Corvette", "Corvette Z06", "Corvette ZR1", "Chevrolet SS"],
        Pontiac: ["GTO", "G8 GT", "G8 GXP"],
        Cadillac: ["CTS-V"],
        Holden: ["Commodore VE", "Commodore VF", "Caprice", "Ute"],
        HSV: ["Clubsport", "GTS", "Maloo", "Senator"]
      },
      modelYears: { Chevrolet: { "Camaro SS": "2010-2015", "Camaro ZL1": "2012-2015", Corvette: "2005-2013", "Corvette Z06": "2006-2013", "Corvette ZR1": "2009-2013", "Chevrolet SS": "2014-2017" }, Pontiac: { GTO: "2005-2006", "G8 GT": "2008-2009", "G8 GXP": "2009" }, Cadillac: { "CTS-V": "2006-2015" } },
      engineRules: [
        { engine: "6.0L LS2", years: "2005-2007", appliesTo: ["Pontiac GTO", "Chevrolet Corvette", "Cadillac CTS-V", "Holden Commodore VE", "HSV Clubsport", "HSV GTS", "HSV Maloo", "HSV Senator"] },
        { engine: "6.0L L76", years: "2008-2009", appliesTo: ["Pontiac G8 GT"] },
        { engine: "6.2L LS3", years: "2008-2017", appliesTo: ["Chevrolet Camaro SS", "Chevrolet Corvette", "Pontiac G8 GXP", "Chevrolet SS", "Holden Commodore VE", "Holden Commodore VF", "Holden Caprice", "Holden Ute", "HSV Clubsport", "HSV Maloo", "HSV Senator"] },
        { engine: "6.2L L99", years: "2010-2015", appliesTo: ["Chevrolet Camaro SS"], note: "Automatic Camaro SS only" },
        { engine: "6.2L LSA", years: "2009-2015", appliesTo: ["Cadillac CTS-V", "Chevrolet Camaro ZL1", "HSV GTS"] },
        { engine: "7.0L LS7", years: "2006-2013", appliesTo: ["Chevrolet Corvette Z06"] },
        { engine: "6.2L LS9", years: "2009-2013", appliesTo: ["Chevrolet Corvette ZR1"] }
      ],
      forcedInductionEngines: ["6.2L LSA", "6.2L LS9"]
    },
    {
      id: "gen5_gm_truck_suv",
      label: "2014-2018 Gen V GM Truck & SUV / EcoTec3 Platform",
      years: "2014-2018",
      baseProductKey: "gen5_gm_truck_suv",
      makes: {
        Chevrolet: ["Silverado 1500", "Silverado 2500 HD", "Silverado 3500 HD", "Tahoe", "Suburban", "Express"],
        GMC: ["Sierra 1500", "Sierra 2500 HD", "Sierra 3500 HD", "Sierra Denali", "Yukon", "Yukon XL", "Yukon Denali", "Savana"],
        Cadillac: ["Escalade", "Escalade ESV"]
      },
      modelYears: { Chevrolet: { "Silverado 1500": "2014-2018", "Silverado 2500 HD": "2014-2018", "Silverado 3500 HD": "2014-2018", Tahoe: "2015-2018", Suburban: "2015-2018", Express: "2014-2018" }, GMC: { "Sierra 1500": "2014-2018", "Sierra 2500 HD": "2014-2018", "Sierra 3500 HD": "2014-2018", "Sierra Denali": "2014-2018", Yukon: "2015-2018", "Yukon XL": "2015-2018", "Yukon Denali": "2015-2018", Savana: "2014-2018" }, Cadillac: { Escalade: "2015-2018", "Escalade ESV": "2015-2018" } },
      engineRules: [
        { engine: "4.3L LV3", years: "2014-2018", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500"] },
        { engine: "4.8L L20", years: "2014-2017", appliesTo: ["Chevrolet Express", "GMC Savana"] },
        { engine: "4.3L LV1", years: "2018", appliesTo: ["Chevrolet Express", "GMC Savana"] },
        { engine: "6.0L L96", years: "2014-2018", appliesTo: ["Chevrolet Silverado 2500 HD", "Chevrolet Silverado 3500 HD", "GMC Sierra 2500 HD", "GMC Sierra 3500 HD", "Chevrolet Express", "GMC Savana"] },
        { engine: "5.3L L83", years: "2014-2018", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500", "Chevrolet Tahoe", "GMC Yukon", "Chevrolet Suburban", "GMC Yukon XL"] },
        { engine: "6.2L L86", years: "2014-2018", appliesTo: ["Cadillac Escalade", "Cadillac Escalade ESV", "GMC Yukon Denali", "GMC Sierra Denali", "Chevrolet Silverado 1500"] }
      ]
    },
    {
      id: "gen5_gm_truck_suv_2019_plus",
      label: "2019-Present Gen V GM Truck & SUV / EcoTec3 & L8T Platform",
      years: "2019-Present",
      baseProductKey: "gen5_gm_truck_suv",
      makes: {
        Chevrolet: ["Silverado 1500", "Silverado 2500 HD", "Silverado 3500 HD", "Tahoe", "Suburban", "Express"],
        GMC: ["Sierra 1500", "Sierra 2500 HD", "Sierra 3500 HD", "Yukon", "Yukon XL", "Yukon Denali", "Yukon XL Denali", "Savana"],
        Cadillac: ["Escalade", "Escalade ESV"]
      },
      engineRules: [
        { engine: "4.3L LV3", years: "2019-2021", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500"] },
        { engine: "4.3L LV1", years: "2019-Present", appliesTo: ["Chevrolet Express", "GMC Savana"] },
        { engine: "6.0L L96", years: "2019-2020", appliesTo: ["Chevrolet Express", "GMC Savana"] },
        { engine: "5.3L L82", years: "2019-2021", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500"] },
        { engine: "5.3L L84", years: "2019-Present", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500"] },
        { engine: "5.3L L83", years: "2019-2020", appliesTo: ["Chevrolet Tahoe", "Chevrolet Suburban", "GMC Yukon", "GMC Yukon XL"] },
        { engine: "5.3L L84", years: "2021-Present", appliesTo: ["Chevrolet Tahoe", "Chevrolet Suburban", "GMC Yukon", "GMC Yukon XL"] },
        { engine: "6.2L L86", years: "2019-2020", appliesTo: ["Chevrolet Tahoe", "Chevrolet Suburban", "GMC Yukon", "GMC Yukon XL", "GMC Yukon Denali", "GMC Yukon XL Denali", "Cadillac Escalade", "Cadillac Escalade ESV"] },
        { engine: "6.2L L87", years: "2019-Present", appliesTo: ["Chevrolet Silverado 1500", "GMC Sierra 1500"] },
        { engine: "6.2L L87", years: "2021-Present", appliesTo: ["Chevrolet Tahoe", "Chevrolet Suburban", "GMC Yukon", "GMC Yukon XL", "GMC Yukon Denali", "GMC Yukon XL Denali", "Cadillac Escalade", "Cadillac Escalade ESV"] },
        { engine: "6.0L L96", years: "2019", appliesTo: ["Chevrolet Silverado 2500 HD", "Chevrolet Silverado 3500 HD", "GMC Sierra 2500 HD", "GMC Sierra 3500 HD"] },
        { engine: "6.6L L8T", years: "2020-Present", appliesTo: ["Chevrolet Silverado 2500 HD", "Chevrolet Silverado 3500 HD", "GMC Sierra 2500 HD", "GMC Sierra 3500 HD"] },
        { engine: "6.6L L8T", years: "2021-Present", appliesTo: ["Chevrolet Express", "GMC Savana"] }
      ]
    },
    {
      id: "gen5_gm_car",
      label: "Gen V GM Car Platform",
      years: "2014-Present",
      baseProductKey: "gen5_gm_car",
      makes: {
        Chevrolet: ["Camaro SS", "Camaro ZL1", "Corvette Stingray", "Corvette Z06", "Corvette ZR1"],
        Cadillac: ["CTS-V", "CT5-V Blackwing"]
      },
      modelYears: { Chevrolet: { "Camaro SS": "2016-2024", "Camaro ZL1": "2017-2024", "Corvette Stingray": "2014-2019", "Corvette Z06": "2015-2019", "Corvette ZR1": "2019" }, Cadillac: { "CTS-V": "2016-2019", "CT5-V Blackwing": "2022-Present" } },
      engineRules: [
        { engine: "6.2L LT1", years: "2014-2024", appliesTo: ["Chevrolet Camaro SS", "Chevrolet Corvette Stingray"] },
        { engine: "6.2L LT4", years: "2015-Present", appliesTo: ["Chevrolet Camaro ZL1", "Chevrolet Corvette Z06", "Cadillac CTS-V", "Cadillac CT5-V Blackwing"] },
        { engine: "6.2L LT5", years: "2019", appliesTo: ["Chevrolet Corvette ZR1"] }
      ],
      forcedInductionEngines: ["6.2L LT4", "6.2L LT5"]
    },
    {
      id: "hemi_ram_2009_2012",
      label: "2009-2012 RAM / Dodge HEMI Truck Platform",
      years: "2009-2012",
      baseProductKey: "hemi_ram_2009_2012",
      makes: {
        RAM: ["Ram 1500", "Ram 2500", "Ram 3500", "Ram Sport", "Ram R/T", "Ram Outdoorsman", "Ram Laramie", "Ram Longhorn", "Ram Power Wagon", "Ram Tradesman", "Ram Fleet"],
        Dodge: ["Ram 1500", "Ram 2500", "Ram 3500", "Dodge Ram 1500", "Dodge Ram 2500", "Dodge Ram 3500", "Durango", "Durango HEMI", "Durango Citadel HEMI", "Durango R/T"],
        Chrysler: ["Aspen", "Aspen Hybrid"],
        Jeep: ["Grand Cherokee", "Grand Cherokee HEMI", "Grand Cherokee Overland HEMI", "Grand Cherokee Summit HEMI", "Grand Cherokee SRT8", "Commander", "Commander HEMI", "Commander Overland"]
      },
      engineRules: [
        { engine: "5.7L Eagle HEMI", appliesTo: ["RAM Ram", "Dodge Ram", "Dodge Durango", "Chrysler Aspen", "Jeep Grand Cherokee", "Jeep Commander"] },
        { engine: "6.1L HEMI", years: "2009-2010", appliesTo: ["Jeep Grand Cherokee SRT8"] },
        { engine: "6.4L / 392 Apache HEMI", years: "2012", appliesTo: ["Jeep Grand Cherokee SRT8"] }
      ]
    },
    {
      id: "hemi_car_2009_2014",
      label: "2009-2014 HEMI Car Platform",
      years: "2009-2014",
      baseProductKey: "hemi_car_2009_2014",
      makes: {
        Dodge: ["Charger", "Charger R/T", "Charger Road & Track", "Charger Daytona", "Charger Pursuit", "Charger Police Package", "Charger Super Bee", "Charger SRT8", "Challenger", "Challenger R/T", "Challenger Classic", "Challenger SRT8", "Challenger SRT8 392"],
        Chrysler: ["300", "300C", "300C AWD", "300 SRT8", "300C SRT8 Export"]
      },
      engineRules: [
        { engine: "5.7L Eagle HEMI", appliesTo: ["Dodge Charger", "Dodge Challenger", "Chrysler 300", "Chrysler 300C"] },
        { engine: "6.1L HEMI", years: "2009-2010", appliesTo: ["Dodge Charger SRT8", "Dodge Challenger SRT8", "Chrysler 300 SRT8", "Chrysler 300C SRT8 Export"] },
        { engine: "6.4L / 392 Apache HEMI", years: "2011-2014", appliesTo: ["Dodge Charger SRT8", "Dodge Charger Super Bee", "Dodge Challenger SRT8", "Dodge Challenger SRT8 392", "Chrysler 300 SRT8"] }
      ]
    },
    {
      id: "hemi_ram_2013_2018",
      label: "2013-2018 RAM HEMI Truck Platform",
      years: "2013-2018",
      baseProductKey: "hemi_ram_2013_2018",
      makes: {
        RAM: ["Ram 1500", "Ram 1500 Tradesman HEMI", "Ram 1500 Express", "Ram 1500 Big Horn", "Ram 1500 Lone Star", "Ram 1500 Outdoorsman", "Ram 1500 Sport", "Ram 1500 Rebel", "Ram 1500 Laramie", "Ram 1500 Longhorn", "Ram 1500 Limited", "Ram 1500 Night Edition", "Ram 1500 Black Express", "Ram 1500 R/T", "Ram 1500 Hydro Blue Sport", "Ram 1500 Sublime Sport", "Ram 1500 Copper Sport", "Ram 2500", "Ram 3500", "Ram 4500", "Ram 5500", "Ram Chassis Cab", "Ram Power Wagon", "Ram Tradesman HEMI", "Ram Fleet"],
        Dodge: ["Durango", "Durango R/T", "Durango Citadel HEMI"],
        Jeep: ["Grand Cherokee", "Grand Cherokee Limited HEMI", "Grand Cherokee Overland HEMI", "Grand Cherokee Summit HEMI", "Grand Cherokee Trailhawk HEMI", "Grand Cherokee SRT", "Grand Cherokee Trackhawk"]
      },
      engineRules: [
        { engine: "5.7L Eagle HEMI", appliesTo: ["RAM Ram 1500", "RAM Ram Tradesman HEMI", "RAM Ram Fleet", "Dodge Durango", "Jeep Grand Cherokee"] },
        { engine: "6.4L BGE HEMI", years: "2014-2018", appliesTo: ["RAM Ram 2500", "RAM Ram 3500", "RAM Ram 4500", "RAM Ram 5500", "RAM Ram Chassis Cab", "RAM Ram Power Wagon"] },
        { engine: "6.4L / 392 Apache HEMI", years: "2013-2018", appliesTo: ["Jeep Grand Cherokee SRT"] },
        { engine: "6.2L Supercharged Hellcat HEMI", years: "2018", appliesTo: ["Jeep Grand Cherokee Trackhawk"] }
      ]
    },
    {
      id: "hemi_car_2015_2023",
      label: "2015-2023 HEMI Car / SRT Platform",
      years: "2015-2023",
      baseProductKey: "hemi_car_2015_2023",
      // Special editions must not inherit every year in the service platform.
      // Dates follow the manufacturer release records in the review package.
      modelYears: {
        Chrysler: { "300C HEMI": "2015-2020", "300C Final Edition": "2023" },
        Dodge: {
          "Charger Hellcat Redeye": "2021-2023",
          "Challenger Hellcat Redeye": "2019-2023",
          "Challenger Super Stock": "2020-2023",
          "Charger Jailbreak": "2022-2023",
          "Challenger Jailbreak": "2022-2023",
          "Challenger SRT Demon": "2018",
          "Challenger Demon 170": "2023",
          "Challenger Black Ghost": "2023",
          "Challenger Swinger": "2023"
        }
      },
      makes: {
        Dodge: ["Charger", "Charger R/T", "Charger Daytona", "Charger Scat Pack", "Charger SRT 392", "Charger SRT Hellcat", "Charger Hellcat Redeye", "Charger Jailbreak", "Charger Super Bee", "Charger Pursuit", "Charger Widebody", "Challenger", "Challenger R/T", "Challenger R/T Classic", "Challenger Shaker", "Challenger T/A", "Challenger Scat Pack", "Challenger SRT 392", "Challenger SRT Hellcat", "Challenger Hellcat Redeye", "Challenger Super Stock", "Challenger SRT Demon", "Challenger Demon 170", "Challenger Jailbreak", "Challenger Black Ghost", "Challenger Swinger", "Challenger Drag Pak"],
        Chrysler: ["300", "300C HEMI", "300S HEMI", "300 Limited HEMI", "300 Glacier Edition", "300 SRT8", "300C Executive Series", "300C Final Edition"]
      },
      engineRules: [
        { engine: "5.7L Eagle HEMI", appliesTo: ["Dodge Charger", "Dodge Challenger", "Chrysler 300"] },
        { engine: "6.4L / 392 Apache HEMI", appliesTo: ["Dodge Charger Scat Pack", "Dodge Charger SRT 392", "Dodge Charger Super Bee", "Dodge Challenger Scat Pack", "Dodge Challenger SRT 392", "Dodge Challenger Swinger", "Chrysler 300 SRT8", "Chrysler 300C Final Edition"] },
        { engine: "6.2L Supercharged Hellcat HEMI", appliesTo: ["Dodge Charger SRT Hellcat", "Dodge Charger Hellcat Redeye", "Dodge Charger Jailbreak", "Dodge Challenger SRT Hellcat", "Dodge Challenger Hellcat Redeye", "Dodge Challenger Super Stock", "Dodge Challenger SRT Demon", "Dodge Challenger Demon 170", "Dodge Challenger Jailbreak", "Dodge Challenger Black Ghost"] }
      ],
      forcedInductionEngines: ["6.2L Supercharged Hellcat HEMI"]
    },
    {
      id: "hemi_ram_2019_2022",
      label: "2019-2022 RAM / Jeep / Dodge HEMI Truck & SUV Platform",
      years: "2019-2022",
      baseProductKey: "hemi_ram_2019_2022",
      modelYears: {
        RAM: {
          "Ram TRX": "2021-2022",
          "Ram TRX Havoc": "2023",
          "Ram TRX Lunar": "2023",
          "Ram TRX Sandblast": "2022",
          "Ram TRX Ignition": "2022"
        },
        Dodge: { "Durango Hellcat": "2021" },
        Jeep: {
          "Wrangler Rubicon 392": "2021-2022",
          "Wrangler 392 Final Edition": "2024",
          "Wagoneer 5.7 HEMI": "2022",
          "Grand Wagoneer 6.4 HEMI": "2022"
        }
      },
      makes: {
        RAM: ["Ram 1500 DT", "Ram 1500 Classic", "Ram 1500 Tradesman HEMI", "Ram 1500 Big Horn", "Ram 1500 Lone Star", "Ram 1500 Laramie", "Ram 1500 Rebel", "Ram 1500 Limited", "Ram 1500 Longhorn", "Ram 1500 Sport", "Ram 1500 Night Edition", "Ram 1500 Built to Serve", "Ram 1500 BackCountry", "Ram 1500 G/T", "Ram 1500 Warlock", "Ram 2500", "Ram 3500", "Ram 4500", "Ram 5500", "Ram Chassis Cab", "Ram Power Wagon", "Ram TRX", "Ram TRX Havoc", "Ram TRX Lunar", "Ram TRX Sandblast", "Ram TRX Ignition"],
        Dodge: ["Durango", "Durango R/T", "Durango Citadel HEMI", "Durango SRT 392", "Durango Hellcat"],
        Jeep: ["Grand Cherokee", "Grand Cherokee Limited HEMI", "Grand Cherokee Overland HEMI", "Grand Cherokee Summit HEMI", "Grand Cherokee Trailhawk HEMI", "Grand Cherokee SRT", "Grand Cherokee Trackhawk", "Wrangler Rubicon 392", "Wrangler 392 Final Edition", "Wagoneer 5.7 HEMI", "Grand Wagoneer 6.4 HEMI"]
      },
      engineRules: [
        { engine: "5.7L Eagle HEMI", appliesTo: ["RAM Ram 1500", "RAM Ram 1500 Classic", "Dodge Durango", "Jeep Grand Cherokee", "Jeep Wagoneer"] },
        { engine: "6.4L BGE HEMI", years: "2019-2022", appliesTo: ["RAM Ram 2500", "RAM Ram 3500", "RAM Ram 4500", "RAM Ram 5500", "RAM Ram Chassis Cab", "RAM Ram Power Wagon"] },
        { engine: "6.4L / 392 Apache HEMI", years: "2019-2022", appliesTo: ["Dodge Durango SRT 392", "Jeep Grand Cherokee SRT", "Jeep Wrangler Rubicon 392", "Jeep Wrangler 392 Final Edition", "Jeep Grand Wagoneer"] },
        { engine: "6.2L Supercharged Hellcat HEMI", appliesTo: ["RAM Ram TRX", "Dodge Durango Hellcat", "Jeep Grand Cherokee Trackhawk"] }
      ],
      forcedInductionEngines: ["6.2L Supercharged Hellcat HEMI"]
    }
  ]
};

window.JRJ_TUNE_BUILDER_DRAFT.homepage = {
  // CSV-governed source of truth for paid tune modification products.
  // Products labeled GEN V are used only when the selected GM engine is
  // classified as Gen V. Gen III, Gen IV, and every HEMI use standard mods.
  // Builders resolve these handles live through /products/<handle>.js so Shopify's
  // current product/variant IDs and prices stay authoritative after product edits.
  addonProducts: {
    "Long Tube Headers": { title: "Tune Add-On: Long Tube Headers + Y-Pipe/X-Pipe", handle: "tune-add-on-long-tube-headers-y-pipe-x-pipe", priceCents: 2099 },
    "Throttle Body Upgrade": { title: "Tune Add-On: Throttle Body Upgrade", handle: "tune-add-on-throttle-body-upgrade", priceCents: 1499 },
    "Aftermarket Injectors": { title: "Tune Add-On: Upgraded Injectors", handle: "tune-add-on-upgraded-injectors", priceCents: 2099 },
    "Gear Ratio Change": { title: "Tune Add-On: Gear Ratio Change", handle: "tune-add-on-gear-ratio-tire-size-change", priceCents: 899 },
    "Tire Size Change": { title: "Tune Add-On: Tire Size Change", handle: "tune-add-on-tire-size-change", priceCents: 899 },
    "Transmission Tune": { title: "Tune Add-On: Transmission Tune", handle: "tune-add-on-transmission-tune", priceCents: 2499 },
    "Aftermarket Intake Manifold": { title: "Tune Add-On: Upgraded Intake Manifold", handle: "tune-add-on-upgraded-intake-manifold", priceCents: 2099 },
    "Cold Air Intake": { title: "Cold Air Intake tune add-on", handle: "dod-mds-cold-air-intake-tune-add-on", priceCents: 999 },
    "MAF Sensor / Housing": { title: "Tune Add-On: MAF Sensor / Housing Upgrade", handle: "tune-add-on-maf-sensor-housing-upgrade", priceCents: 1099 },
    "E85 / Flex Fuel": { title: "Tune Add-On: E85 / Flex Fuel", handle: "tune-add-on-e85-flex-fuel", priceCents: 1499 },
    "Ported Heads": { title: "Tune Add-On: Aftermarket / Ported Heads", handle: "tune-add-on-aftermarket-ported-heads", priceCents: 1499 },
    "Aftermarket Torque Converter": { title: "Tune Add-On: Aftermarket Torque Converter", handle: "tune-add-on-aftermarket-torque-converter", priceCents: 2499 },
    "Rush Turnaround": { title: "Tune Add-On: Rush Turnaround", handle: "tune-add-on-rush-turnaround", priceCents: 9999 }
  },
  genVAddonProducts: {
    "Long Tube Headers": { title: "GEN V Long Tube Headers", handle: "tune-add-on-long-tube-headers-y-pipe-x-pipe-gen-v", priceCents: 3499 },
    "Throttle Body Upgrade": { title: "GEN V Throttle Body", handle: "tune-add-on-throttle-body-upgrade-gen-v", priceCents: 2499 },
    "Aftermarket Injectors": { title: "GEN V: Tune Add-On: Upgraded Injectors", handle: "tune-add-on-upgraded-injectors-gen-v", priceCents: 3499 },
    "Transmission Tune": { title: "GEN V Transmission Tune", handle: "tune-add-on-transmission-tune-gen-v", priceCents: 4499 },
    "Aftermarket Intake Manifold": { title: "GEN V Intake Manifold", handle: "tune-add-on-upgraded-intake-manifold-gen-v", priceCents: 3499 },
    "Ported Heads": { title: "GEN V Ported Heads", handle: "gen-v-tune-add-on-aftermarket-ported-heads", priceCents: 3499 },
    "Aftermarket Torque Converter": { title: "GEN V Torque Converter", handle: "gen-v-tune-add-on-aftermarket-torque-converter", priceCents: 4499 }
  },
  // Legacy ID maps are retained only for the disabled legacy homepage section.
  // Active builders resolve the CSV-governed handles above instead.
  addonVariants: {
    "Long Tube Headers": 43148357304387,
    "Throttle Body Upgrade": 43148357369923,
    "Aftermarket Injectors": 43444389969987,
    "Gear Ratio Change": 43148357894211,
    "Tire Size Change": 43403746771011,
    "Transmission Tune": 43236236132419,
    "Aftermarket Intake Manifold": 43148357337155,
    "Cold Air Intake": 43333778833475,
    "Ported Heads": 43148357566531,
    "Aftermarket Torque Converter": 43148357828675,
    "Rush Turnaround": 43236236230723
  },
  genVAddonVariants: {
    "Long Tube Headers": 43444388036675,
    "Throttle Body Upgrade": 43444380696643,
    "Aftermarket Injectors": 43444389969987,
    "Transmission Tune": 43444386005059,
    "Aftermarket Intake Manifold": 43444392165443,
    "Ported Heads": 43444393508931,
    "Aftermarket Torque Converter": 43444397998147
  },
  basicProducts: {
    BASIC_DOD_AFM_DELETE: { title: "Basic DOD / AFM Delete Tune", variantId: 43403420074051 },
    BASIC_MDS_DELETE: { title: "Basic MDS Delete Tune", variantId: 43403421253699 },
    BASIC_VVT_DELETE: { title: "Basic VVT Delete Tune", variantId: 43403423055939 }
  },
  camUpgradeProducts: {
    STAGE_2_CAM_UPGRADE: { title: "Tune Add-On: Stage 2 Cam", handle: "tune-add-on-stage-2-cam", priceCents: 3499 },
    STAGE_3_CAM_UPGRADE: { title: "Tune Add-On: Stage 3 Cam", handle: "tune-add-on-stage-3-cam", priceCents: 4499 },
    STAGE_4_CAM_UPGRADE: { title: "Tune Add-On: Stage 4 Cam", handle: "tune-add-on-stage-4-cam", priceCents: 5499 },
    GEN_V_STAGE_2_CAM_UPGRADE: { title: "GEN V Tune Add-On: Stage 2 Cam", handle: "gen-v-tune-add-on-stage-2-cam", priceCents: 5499 },
    GEN_V_STAGE_3_CAM_UPGRADE: { title: "GEN V Tune Add-On: Stage 3 Cam", handle: "gen-v-tune-add-on-stage-3-cam", priceCents: 7499 },
    GEN_V_STAGE_4_CAM_UPGRADE: { title: "GEN V Tune Add-On: Stage 4 Cam", handle: "gen-v-tune-add-on-stage-4-cam", priceCents: 7499 }
  },
  camOptions: {
    // GM catalogs are split by actual engine architecture and application.
    // Product pages use the safe fallback until an engine is entered; the
    // guided builders resolve these same keys from their engine selectors.
    "GM Safe Fallback": ["Cam Not Listed - Enter Cam Specs"],
    "GM LS Truck Cathedral": [
      "BTR Truck Norris",
      "Texas Speed Chopacabra",
      "BTR Truck Norris NSR",
      "Texas Speed NSR Chopacabra",
      "Texas Speed Stage 2",
      "Texas Speed Stage 3",
      "BTR Stage 2",
      "BTR Stage 3",
      "Sloppy Mechanics Stage 2",
      "Sloppy Mechanics Stage 3",
      "Comp Cams 54-450-11",
      "Texas Speed Stage 4 Low Lift Truck Cam",
      "Texas Speed Stage 4 High Lift Truck Cam",
      "Texas Speed OnDGas Stage 4",
      "BTR Gen III/IV LS Truck Stage 1 V3",
      "BTR Gen III/IV LS Truck Stage 2 V3",
      "BTR Gen III/IV LS Truck Stage 3 V3",
      "BTR Gen III/IV LS Truck Stage 4 V3",
      "BTR Truck Hoss Cam",
      "BTR Truck Torque Cam",
      "BTR Stage 2 NSR Truck Cam",
      "BTR 400+ Low-Lift Truck Cam",
      "BTR 5.3L DOD Conversion Cam",
      "BTR 6.0L/6.2L DOD Conversion Cam",
      "TSP Liberty Stick Truck Cam",
      "TSP OnDGas Stage 1 Truck Cam",
      "TSP OnDGas Stage 2 Truck Cam",
      "TSP OnDGas Stage 3 Truck Cam",
      "TSP Low-Lift Stage 1 Truck Cam",
      "TSP Low-Lift Stage 3 Truck Cam",
      "TSP High-Lift Stage 2 Truck Cam",
      "TSP High-Lift Stage 3 Truck Cam",
      "TSP B.F.D. 5.3L LS Truck Cam",
      "TSP 224R Cam",
      "TSP 228R Cam",
      "TSP 224/228 Cam",
      "TSP 228/232 Cam",
      "COMP XFI Truck 208/212 (54-451-11)",
      "COMP HRT NSR 218/226 (54-271-11)",
      "COMP HRT 218/226 (54-273-11)",
      "COMP HRT 226/234 (54-275-11)",
      "COMP Thumpr 218/229 (54-700-11)",
      "COMP Thumpr 222/233 (54-701-11)",
      "COMP Thumpr 219/233 (54-600-11)",
      "COMP XFI 206/212 (54-408-11)",
      "COMP XFI 212/218 (54-412-11)",
      "COMP XFI 216/220 (54-414-11)",
      "COMP XFI 212/218 (54-424-11)",
      "COMP XFI 222/224 (54-426-11)",
      "COMP XFI 228/230 (54-428-11)",
      "COMP XFI 224/230 (54-444-11)",
      "COMP XFI 232/234 (54-446-11)",
      "COMP XFI 238/240 (54-448-11)",
      "SDPC Hot Truck Torque Cam (SD0053)",
      "SDPC Hot Truck 1 214/218 Cam",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM LS Truck Rectangle": [
      "BTR Truck Norris",
      "Texas Speed Chopacabra",
      "BTR Truck Norris NSR",
      "Texas Speed NSR Chopacabra",
      "Texas Speed Stage 2",
      "Texas Speed Stage 3",
      "BTR Stage 2",
      "BTR Stage 3",
      "Sloppy Mechanics Stage 2",
      "Sloppy Mechanics Stage 3",
      "Comp Cams 54-450-11",
      "Comp Cams 54-469-11",
      "Texas Speed Stage 4 Low Lift Truck Cam",
      "Texas Speed Stage 4 High Lift Truck Cam",
      "Texas Speed OnDGas Stage 4",
      "BTR Gen III/IV LS Truck Stage 1 V3",
      "BTR Gen III/IV LS Truck Stage 2 V3",
      "BTR Gen III/IV LS Truck Stage 3 V3",
      "BTR Gen III/IV LS Truck Stage 4 V3",
      "BTR Truck Hoss Cam",
      "BTR Truck Torque Cam",
      "BTR Stage 2 NSR Truck Cam",
      "BTR 400+ Low-Lift Truck Cam",
      "BTR 6.0L/6.2L DOD Conversion Cam",
      "TSP Liberty Stick Truck Cam",
      "TSP OnDGas Stage 1 Truck Cam",
      "TSP OnDGas Stage 2 Truck Cam",
      "TSP OnDGas Stage 3 Truck Cam",
      "TSP L92 6.2L Truck Stage 1 Cam",
      "TSP L92 6.2L Truck Stage 2 Cam",
      "TSP L92 6.2L Truck Stage 3 Cam",
      "TSP Low-Lift Stage 1 Truck Cam",
      "TSP Low-Lift Stage 3 Truck Cam",
      "TSP High-Lift Stage 2 Truck Cam",
      "TSP High-Lift Stage 3 Truck Cam",
      "COMP LSR Rectangle-Port 219/235 (54-453-11)",
      "COMP LSR Rectangle-Port 227/243 (54-454-11)",
      "COMP LSR Rectangle-Port 231/247 (54-469-11)",
      "COMP LSR Rectangle-Port 235/251 (54-470-11)",
      "COMP LSR Rectangle-Port 239/255 (54-471-11)",
      "COMP LSR Rectangle-Port 251/267 (54-474-11)",
      "COMP HRT NSR 218/226 (54-271-11)",
      "COMP HRT 218/226 (54-273-11)",
      "COMP HRT 226/234 (54-275-11)",
      "COMP Single-Bolt FSL 206/218 (146-200-13)",
      "COMP Single-Bolt FSL 210/222 (146-201-13)",
      "COMP Single-Bolt XFI 222/234 (146-426-11)",
      "COMP VVT/AFM FSL 206/218 (689-200-13)",
      "COMP VVT/AFM FSL 210/222 (689-201-13)",
      "COMP VVT 210/224 (189-400-13)",
      "COMP VVT 214/228 (189-401-13)",
      "COMP VVT 218/232 (189-402-13)",
      "COMP VVT Stage 2 237/248 (189-303-13)",
      "SDPC Hot Truck Torque Cam (SD0053)",
      "SDPC HT4 LS 224/236 Cam",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM LS Car Cathedral": [
      "Texas Speed Stage 1 LS1/LS6",
      "Texas Speed Stage 2 LS1/LS6",
      "BTR Stage 2 LS Cam",
      "Comp Cams 54-450-11",
      "BTR LS1/LS2 Stage 1 V2",
      "BTR LS1/LS2 Stage 2 V2",
      "BTR LS1/LS2 Stage 3 V2",
      "BTR LS1/LS2 Stage 4 V2",
      "BTR LS Hot Rod Cam",
      "BTR LS Red Hot Cam",
      "BTR Chevrolet LS6 Cam",
      "BTR LS Turbo Stage 1 V2",
      "BTR LS Turbo Stage 2 V2",
      "BTR LS Turbo Stage 3 V2",
      "BTR LS Turbo Stage 4 V2",
      "BTR 4.8L Stage 2 Turbo Cam",
      "BTR 400+ Medium Turbo Cam",
      "BTR 400+ Big Turbo Cam",
      "BTR 400+ Truck Turbo Cam",
      "BTR LS Stage 1 Centrifugal Cam",
      "BTR LS Stage 2 Centrifugal Cam",
      "TSP Cathedral Turbo Stage 1 Cam",
      "TSP Cathedral Turbo Stage 2 Cam",
      "TSP Cathedral Turbo Stage 3 Cam",
      "TSP 220R Cam",
      "TSP F-117 Stealth Cam",
      "TSP Magic Stick 3 Cam",
      "TSP Bald Eagle Cathedral Stroker Twin-Turbo Cam",
      "TSP Torquer V4 Cam",
      "TSP Magic Stick 4 Cam",
      "TSP 233/239 Cam",
      "TSP Tsunami Cam",
      "TSP Cathedral 3/4 Race Cam",
      "TSP Dumpster Fire Cam",
      "TSP 228R Cam",
      "TSP Bald Eagle LS1/LS2 Boost Cam",
      "TSP B.F.D. 5.7L/6.0L Cam",
      "TSP 224R Cam",
      "TSP 224/228 Cam",
      "TSP 228/232 Cam",
      "TSP Bald Eagle LS1/LS2 N/A Cam",
      "TSP Torquer V2 Cam",
      "Texas Speed Stage 4 Cathedral N/A Cam",
      "COMP LSR Cathedral-Port 215/223 (54-455-11)",
      "COMP LSR Cathedral-Port 219/227 (54-456-11)",
      "COMP LSR Cathedral-Port 223/231 (54-457-11)",
      "COMP LSR Cathedral-Port 227/235 (54-458-11)",
      "COMP LSR Cathedral-Port 231/239 (54-459-11)",
      "COMP LSR Cathedral-Port 235/243 (54-460-11)",
      "COMP XFI 206/212 (54-408-11)",
      "COMP XFI 212/218 (54-412-11)",
      "COMP XFI 216/220 (54-414-11)",
      "COMP XFI 212/218 (54-424-11)",
      "COMP XFI 222/224 (54-426-11)",
      "COMP XFI 228/230 (54-428-11)",
      "COMP XFI 224/230 (54-444-11)",
      "COMP XFI 232/234 (54-446-11)",
      "COMP XFI 238/240 (54-448-11)",
      "COMP Thumpr 219/233 (54-600-11)",
      "COMP Mutha Thumpr 227/241 (54-601-11)",
      "COMP Big Mutha Thumpr 235/249 (54-602-11)",
      "COMP LST Turbo 223/225 (54-330-11)",
      "COMP LST Turbo 225/233 (54-331-11)",
      "COMP LST Turbo 231/237 (54-332-11)",
      "COMP LST Blower 225/239 (54-335-11)",
      "COMP LST Blower 233/247 (54-337-11)",
      "SDPC LS6 Power Max Plus Cam (SDR51902)",
      "SDPC HT4 LS 224/236 Cam",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM LS3/L99 Car Rectangle": [
      "BTR Truck Norris LS3",
      "Texas Speed Chopacabra LS3",
      "Texas Speed Stage 1 LS3",
      "Texas Speed Stage 2 LS3",
      "Texas Speed Stage 3 LS3",
      "BTR Stage 2 LS3 Cam",
      "BTR Stage 3 LS3 Cam",
      "Comp Cams 54-450-11",
      "Comp Cams 54-469-11",
      "BTR LS3 Stage 1 V2",
      "BTR LS3 Stage 2 V2",
      "BTR LS3 Stage 3 V2",
      "BTR LS3 Stage 4 V2",
      "BTR LS3 Stage 5 V2",
      "BTR LS3 Hot Rod Cam",
      "BTR LS3 Red Hot Cam",
      "Chevrolet Performance LS3 Cam (12623063)",
      "GPI SS3 LS3 Cam",
      "GPI SS4 No-Cut LS3 Cam",
      "GPI L99 VVT SS3 Cam",
      "TSP LS3 Stroker Turbo 1200 Cam",
      "TSP LS3 Stroker Turbo 2000 Cam",
      "TSP LS3 PDS Stroker Cam",
      "TSP NSR 6.2L Chopacabra Cam",
      "TSP LS3 Stroker N/A Stage 1 Cam",
      "TSP LS3 Stroker N/A Stage 2 Cam",
      "TSP Bald Eagle LS3 N/A Cam",
      "TSP Bald Eagle LS3 Boost Cam",
      "TSP B.F.D. LS3 Cam",
      "TSP B.F.D. LS3 Stroker Cam",
      "Texas Speed Stage 4 F-35 LS3 N/A Cam",
      "TSP 6.2L Chopacabra Cam",
      "TSP LS3 3/4 Race Cam",
      "TSP LS3 Stage 1 Cam",
      "TSP LS3 Stage 2 Cam",
      "TSP LS3 Stage 3 Cam",
      "TSP LS3 Stroker Centrifugal Cam",
      "TSP Honey Badger LS3 Cam",
      "COMP LSR Rectangle-Port 219/235 (54-453-11)",
      "COMP LSR Rectangle-Port 227/243 (54-454-11)",
      "COMP LSR Rectangle-Port 231/247 (54-469-11)",
      "COMP LSR Rectangle-Port 235/251 (54-470-11)",
      "COMP LSR Rectangle-Port 239/255 (54-471-11)",
      "COMP LSR Rectangle-Port 251/267 (54-474-11)",
      "COMP Single-Bolt FSL 206/218 (146-200-13)",
      "COMP Single-Bolt FSL 210/222 (146-201-13)",
      "COMP Single-Bolt FSL 208/218 (146-103-11)",
      "COMP Single-Bolt LSR 219/235 (146-456-11)",
      "COMP Single-Bolt LSR 227/243 (146-458-11)",
      "COMP Single-Bolt XFI 222/234 (146-426-11)",
      "COMP VVT/AFM FSL 206/218 (689-200-13)",
      "COMP VVT/AFM FSL 210/222 (689-201-13)",
      "COMP VVT/AFM 208/220 (689-199-13)",
      "COMP VVT/AFM 216/228 (689-421-13)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM LSA/LS9 PDS": [
      "BTR LS PDS Stage 1 Cam",
      "BTR LS PDS Stage 2 Cam",
      "BTR LS PDS Stage 3 Cam",
      "BTR LS PDS Stage 4 Cam",
      "BTR LS PDS Stage 1 Cam - 1.8 Rocker",
      "BTR LS PDS Stage 2 Cam - 1.8 Rocker",
      "BTR LS PDS Stage 3 Cam - 1.8 Rocker",
      "BTR LS PDS Stage 4 Cam - 1.8 Rocker",
      "BTR LS PDS Red Hot Cam",
      "Chevrolet Performance LS9 Cam (12638427)",
      "TSP LS3 PDS Cam",
      "TSP LS3 PDS Stroker Cam",
      "TSP Bald Eagle LS3 Boost Cam",
      "TSP B.F.D. LS3 Cam",
      "TSP B.F.D. LS3 Stroker Cam",
      "TSP Honey Badger LS3 Cam",
      "TSP LS3 Stroker Centrifugal Cam",
      "TSP LS3 Stroker Turbo 1200 Cam",
      "TSP LS3 Stroker Turbo 2000 Cam",
      "COMP LST Blower 225/239 (54-335-11)",
      "COMP LST Blower 233/247 (54-337-11)",
      "COMP LST Turbo 223/225 (54-330-11)",
      "COMP LST Turbo 225/233 (54-331-11)",
      "COMP LST Turbo 231/237 (54-332-11)",
      "COMP Blower 231/244 (54-301-11)",
      "COMP Blower 237/248 (54-303-11)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM LS7": [
      "BTR LS7 Stage 1 Cam",
      "BTR LS7 Stage 2 Cam",
      "BTR LS7 Stage 3 Cam",
      "BTR LS7 Stage 4 Cam",
      "TSP LS7 Stage 1 Cam",
      "TSP LS7 Stage 2 Cam",
      "TSP LS7 Stage 4 Cam",
      "Texas Speed Stage 4 LS7 N/A Cam",
      "TSP B.F.D. LS7 Cam",
      "TSP Trailer Park Torpedo LS7 Cam",
      "TSP TX Giant LS7 Stroker Cam",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM Gen V LT1": [
      "Texas Speed Stage 1 LT1",
      "Texas Speed Stage 2 LT1",
      "BTR Stage 2 LT1 Cam",
      "Comp Cams XFI Stage 1 LT1",
      "Comp Cams XFI Stage 2 LT1",
      "BTR Gen V 220 Cam with VVT Limiter",
      "BTR Gen V 225 Cam with VVT Limiter",
      "BTR Gen V 230 Cam with VVT Limiter",
      "BTR Gen V Stage 3 Turbo 3-Bolt Cam",
      "BTR Gen V 6.2L L86/LT1 DOD Conversion Cam",
      "TSP LT1 Stage 1 V2 Cam",
      "TSP LT1 Stage 2 V2 Cam",
      "TSP Bald Eagle LT1 Stroker Boost Cam",
      "TSP EL-C7 3-Bolt Cam",
      "TSP LT1/LT4 V2 Turbo Cam",
      "TSP EL-C7 V2 Cam",
      "TSP LTx 3-Bolt Blower Cam",
      "TSP LTx 3-Bolt Stage 1 Cam",
      "TSP LTx 3-Bolt Stage 2 Cam",
      "TSP LT1/LT4 V2 Supercharger Cam",
      "TSP F-117 LT Cam",
      "TSP LTx WIKD Supercharged Stroker Cam",
      "TSP LTx WIKD Supercharged Stroker 3-Bolt Cam",
      "COMP Gen V AFM 210/222 (624-500-13)",
      "COMP Gen V AFM 214/226 (624-512-13)",
      "COMP Gen V AFM 218/230 (624-524-13)",
      "COMP Gen V AFM 222/234 (624-536-13)",
      "COMP Gen V LST Stage 1 227/238 (224-300-13)",
      "COMP Gen V LST Stage 2 235/248 (224-302-13)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM Gen V LT4/LT5 Supercharged": [
      "BTR Gen V 220 Cam with VVT Limiter",
      "BTR Gen V 225 Cam with VVT Limiter",
      "BTR Gen V 230 Cam with VVT Limiter",
      "BTR Gen V Stage 3 Turbo 3-Bolt Cam",
      "TSP Bald Eagle LT1 Stroker Boost Cam",
      "TSP EL-C7 3-Bolt Cam",
      "TSP LT1/LT4 V2 Turbo Cam",
      "TSP EL-C7 V2 Cam",
      "TSP LTx 3-Bolt Blower Cam",
      "TSP LT1/LT4 V2 Supercharger Cam",
      "TSP F-117 LT Cam",
      "TSP LTx WIKD Supercharged Stroker Cam",
      "TSP LTx WIKD Supercharged Stroker 3-Bolt Cam",
      "COMP Gen V LST Stage 1 227/238 (224-300-13)",
      "COMP Gen V LST Stage 2 235/248 (224-302-13)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM Gen V 5.3 Truck": [
      "BTR Truck Norris (Gen V)",
      "Texas Speed Chopacabra (Gen V)",
      "Texas Speed Stage 1 Truck Cam",
      "Texas Speed Stage 2 Truck Cam",
      "Texas Speed Stage 3 Truck Cam",
      "BTR Stage 2 Truck Cam",
      "BTR Stage 3 Truck Cam",
      "BTR Gen V Truck Stage 1 Cam with VVT Limiter",
      "BTR Gen V Truck Stage 2 Cam with VVT Limiter",
      "BTR Gen V Truck Stage 3 Cam with VVT Limiter",
      "BTR Gen V Truck Stage 4 Cam with VVT Limiter",
      "BTR Gen V 5.3L Truck Norris Cam",
      "BTR Gen V 220 Cam with VVT Limiter",
      "TSP L83 3-Bolt Stage 1 Cam",
      "TSP L83 3-Bolt Stage 2 Cam",
      "TSP L83 3-Bolt Stage 3 Cam",
      "TSP L83 V2 Stage 1 Cam",
      "TSP L83 V2 Stage 2 Cam",
      "TSP L83 V2 Stage 3 Cam",
      "TSP L83 V2 Low-Lift Stage 2 Cam",
      "TSP L83 V2 Turbo Cam",
      "TSP L83 V2 Supercharger Cam",
      "TSP L83 3-Bolt Turbo Cam",
      "TSP L83 3-Bolt Blower Cam",
      "TSP Gen V Chopacabra Truck Cam",
      "TSP B.F.D. L83 Cam",
      "TSP LTx WIKD Supercharged Stroker Cam",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM Gen V 6.2 Truck": [
      "BTR Truck Norris (Gen V)",
      "Texas Speed Chopacabra (Gen V)",
      "Texas Speed Stage 1 Truck Cam",
      "Texas Speed Stage 2 Truck Cam",
      "Texas Speed Stage 3 Truck Cam",
      "BTR Stage 2 Truck Cam",
      "BTR Stage 3 Truck Cam",
      "BTR Gen V Truck Stage 1 Cam with VVT Limiter",
      "BTR Gen V Truck Stage 2 Cam with VVT Limiter",
      "BTR Gen V Truck Stage 3 Cam with VVT Limiter",
      "BTR Gen V Truck Stage 4 Cam with VVT Limiter",
      "BTR Gen V 220 Cam with VVT Limiter",
      "BTR Gen V 6.2L L86/LT1 DOD Conversion Cam",
      "TSP L86 Stage 1 Truck Cam",
      "TSP L86 Stage 2 Truck Cam",
      "TSP Gen V Chopacabra Truck Cam",
      "TSP LTx WIKD Supercharged Stroker Cam",
      "TSP LTx WIKD Supercharged Stroker 3-Bolt Cam",
      "COMP Gen V LST Stage 1 227/238 (224-300-13)",
      "COMP Gen V LST Stage 2 235/248 (224-302-13)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM Gen V L8T": [
      "BTR Gen V L8T Torque Cam with VVT Limiter",
      "Chevrolet Performance L8T Non-DOD Cam (12742436)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "GM Gen V LV3/LV1 V6": [
      "Texas Speed LV3 Stage 1 Cam",
      "Texas Speed LV3 Stage 2 Cam",
      "Texas Speed LV3 Stage 3 Cam",
      "BTR LV3 Stage 1 Cam",
      "BTR LV3 Stage 2 Cam",
      "COMP LV3 NSR Cam",
      "COMP LV3 Stage 1 Cam",
      "COMP LV3 Stage 2 Cam",
      "SDPC LV3 Stage 1 Cam (SDR15976)",
      "SDPC LV3 Stage 2 Cam (SDR15977)",
      "Genuine GM LV1 Non-AFM Cam (12721599)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    // Product pages start with this safe fallback until the customer enters
    // an engine. Homepage and mini builders always resolve one of the four
    // engine-precise lists below. Keeping the fallback intentionally narrow
    // prevents a 5.7 VVT cam from being suggested for a 6.1 non-VVT or
    // Hellcat application.
    "Dodge RAM HEMI": ["Cam Not Listed - Enter Cam Specs"],
    "HEMI 5.7 VVT": [
      "BTR Truck Norris",
      "TSP Chopacabra 5.7L HEMI",
      "BTR 5.7 HEMI VVT Stage 1",
      "BTR 5.7 HEMI VVT Stage 2",
      "BTR 5.7 HEMI VVT Stage 3",
      "BTR 5.7 HEMI VVT Stage 4",
      "TSP B.F.D. Chop Monster 5.7L HEMI",
      "TSP Warthog 5.7L HEMI 219/232",
      "TSP 5.7L HEMI Low-Lift Stage 1",
      "TSP 5.7L HEMI Low-Lift Stage 2",
      "TSP 09+ HEMI N/A Stage 1",
      "TSP 09+ HEMI N/A Stage 2",
      "TSP 09+ HEMI N/A Stage 3",
      "TSP 09+ HEMI N/A Stage 4",
      "TSP 09+ HEMI Boost Stage 3",
      "TSP 09+ HEMI Boost Stage 4",
      "COMP HRT NSR Stage 1 216/222 (201-300-17)",
      "COMP HRT Stage 2 220/230 (201-303-17)",
      "COMP HRT Stage 3 224/234 (201-305-17)",
      "COMP HRT Turbo Stage 1 221/229 (201-330-17)",
      "COMP HRT Turbo Stage 2 229/237 (201-332-17)",
      "COMP HRT Supercharger Stage 1 221/233 (201-335-17)",
      "COMP HRT Supercharger Stage 2 229/241 (201-337-17)",
      "COMP Thumpr NSR 214/233 (201-700-17)",
      "COMP XFI 218/226 (201-424-17)",
      "COMP XFI 222/230 (201-426-17)",
      "COMP XFI 226/234 (201-428-17)",
      "SDPC Stage 1 213/219 (SDRH213219)",
      "SDPC El Choppo 215/221 (SDRHElChoppo)",
      "SDPC Stage 2 218/225 (SDRH218225)",
      "SDPC Stage 3 223/231 (SDRH223231)",
      "MMX 5.7 VVT No-Tune MDS (MM-NTR-NSR-MDS)",
      "MMX 5.7 VVT No-Tune Non-MDS (MM-NTR-NSR-NONMDS)",
      "MMX 5.7 VVT CHOPSTIX (MM-NA5.7CHOPSTIX)",
      "MMX 5.7 VVT MAXEFFORT (MMX-57-MAXEFFORT)",
      "MMX 5.7 VVT N/A Lope (MMP-214-224HPT+)",
      "MMX 5.7 VVT N/A NSR (MM-NSR-5.7-2)",
      "MMX 5.7 VVT Supercharged V2.0 (MM-5.7-SC-V2)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "HEMI 6.1 NON-VVT": [
      "TSP Non-VVT HEMI Stage 1",
      "TSP Non-VVT HEMI Stage 2",
      "TSP Non-VVT HEMI Stage 3",
      "TSP Non-VVT HEMI Stage 4",
      "TSP Non-VVT HEMI Blower Cam",
      "TSP Non-VVT HEMI Turbo Cam",
      "COMP HRT NSR Stage 1 216/222 (112-300-11)",
      "COMP HRT Stage 2 220/230 (112-303-11)",
      "COMP HRT Turbo Stage 1 221/229 (112-330-11)",
      "COMP HRT Supercharger Stage 1 221/233 (112-335-11)",
      "COMP Thumpr NSR 214/233 (112-700-11)",
      "COMP Tri-Power Xtreme 194/206 (112-525-11)",
      "COMP Tri-Power Xtreme 202/212 (112-530-11)",
      "COMP Tri-Power Xtreme 210/218 (112-535-11)",
      "COMP XFI 208/212 (112-500-11)",
      "COMP XFI 216/220 (112-501-11)",
      "COMP XFI 224/228 (112-502-11)",
      "MMX 6.1 N/A Performance (MMP-BG6.1-LP)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "HEMI 6.4 HD BGE": ["Cam Not Listed - Enter Cam Specs"],
    "HEMI 6.4 VVT": [
      "BTR Truck Norris 6.4L HEMI",
      "TSP Chopacabra 6.4L HEMI",
      "BTR 6.4 HEMI VVT 224",
      "BTR 6.4 HEMI VVT 228",
      "TSP 6.4L HEMI N/A Stage 1",
      "TSP 6.4L HEMI N/A Stage 2",
      "TSP 6.4L HEMI N/A Stage 3",
      "TSP 6.4L HEMI N/A Stage 4",
      "TSP 6.4L HEMI Turbo Cam",
      "TSP 09+ HEMI N/A Stage 1",
      "TSP 09+ HEMI N/A Stage 2",
      "TSP 09+ HEMI N/A Stage 3",
      "TSP 09+ HEMI N/A Stage 4",
      "TSP 09+ HEMI Boost Stage 3",
      "TSP 09+ HEMI Boost Stage 4",
      "COMP HRT NSR Stage 1 218/228 (201-302-17)",
      "COMP HRT Stage 2 220/230 (201-303-17)",
      "COMP HRT Stage 2 222/230 (201-304-17)",
      "COMP HRT Stage 3 224/234 (201-305-17)",
      "COMP HRT Stage 3 228/236 (201-306-17)",
      "COMP HRT Turbo Stage 1 221/229 (201-330-17)",
      "COMP HRT Turbo Stage 2 229/237 (201-332-17)",
      "COMP HRT Supercharger Stage 1 221/233 (201-335-17)",
      "COMP HRT Supercharger Stage 2 229/241 (201-337-17)",
      "COMP Thumpr NSR 214/233 (201-700-17)",
      "COMP XFI 218/226 (201-424-17)",
      "COMP XFI 222/230 (201-426-17)",
      "COMP XFI 226/234 (201-428-17)",
      "SDPC Stage 2 218/225 (SDRH218225)",
      "SDPC Stage 3 223/231 (SDRH223231)",
      "SDPC Stage 4 228/236 (SDRH228236)",
      "SDPC Grizzly Tow Power 222/228 (SDRH222228)",
      "MMX 6.4 RAM No-Tune Non-MDS (MM-BGE6.4NONMDS)",
      "MMX 6.4 RAM No-Tune MDS (MM-BGE6.4MDS)",
      "MMX 6.2/6.4 High-RPM Blower (MM-426-1500-3.8)",
      "MMX 6.2/6.4 PD Twin-Screw Blower (MM-411-TSB)",
      "MMX 6.4 HI-RAM MAX EFFORT (MMX-HIRAM-392)",
      "MMX 6.4 CHOPSTIX NSR (MM-NSR-CHOPSTIX)",
      "MMX 6.4 MAX EFFORT N/A (MMP-ME-NA)",
      "MMX 6.4 MAX EFFORT SC-CENT (MM-SC6.4ME-CENT)",
      "MMX 6.4 MAX EFFORT SC-PD (MM-SC6.4ME-PD)",
      "MMX 6.4 MAX EFFORT V2 N/A (MMX-MAX-V2)",
      "MMX 6.4 N/A NSR (MMP-NSR-STG3-NA)",
      "MMX 6.4 N/A NSR WK2 Megan (MMP-NSR-MEGAN)",
      "MMX 6.4 SC NSR (MMP-NSR-STG3-SC)",
      "MMX 6.4 BGE Towing (MMP-BGE-NA)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "HEMI 6.2 HELLCAT": [
      "TSP Hellcat Stage 1 226/241",
      "TSP Hellcat Stage 2 232/244",
      "TSP Hellcat Stage 3 238/250",
      "TSP 09+ HEMI N/A Stage 1",
      "TSP 09+ HEMI N/A Stage 2",
      "TSP 09+ HEMI N/A Stage 3",
      "TSP 09+ HEMI N/A Stage 4",
      "TSP 09+ HEMI Boost Stage 3",
      "TSP 09+ HEMI Boost Stage 4",
      "SDPC Reaper Hellcat 223/241 (SDRH223241)",
      "MMX 6.2/6.4 High-RPM Blower (MM-426-1500-3.8)",
      "MMX 6.2/6.4 PD Twin-Screw Blower (MM-411-TSB)",
      "MMX Hellcat MAX EFFORT (MM-HC-ME)",
      "MMX Hellcat/Trackhawk NSR (MMP-NSR-HC1+)",
      "Cam Not Listed - Enter Cam Specs"
    ],
    "Other": ["Cam Not Listed - Enter Cam Specs", "Aftermarket Cam - I'll Provide Specs"]
  },
  // These exact-name overrides preserve the existing JRJ Stage 1-4 cam-tune
  // pricing for catalog names that do not contain a stage number. Named
  // products whose labels include "Stage N" continue to use the shared
  // parser, so there is no duplicate pricing table for them.
  camTierOverrides: {
    "BTR Truck Hoss Cam": 3,
    "BTR Truck Torque Cam": 1,
    "BTR 400+ Low-Lift Truck Cam": 2,
    "BTR 5.3L DOD Conversion Cam": 1,
    "BTR 6.0L/6.2L DOD Conversion Cam": 1,
    "TSP Liberty Stick Truck Cam": 2,
    "TSP B.F.D. 5.3L LS Truck Cam": 3,
    "TSP 224R Cam": 2,
    "TSP 228R Cam": 3,
    "SDPC Hot Truck Torque Cam (SD0053)": 1,
    "BTR LS Hot Rod Cam": 3,
    "BTR LS Red Hot Cam": 4,
    "BTR Chevrolet LS6 Cam": 1,
    "BTR 400+ Medium Turbo Cam": 3,
    "BTR 400+ Big Turbo Cam": 4,
    "BTR 400+ Truck Turbo Cam": 2,
    "TSP 220R Cam": 2,
    "TSP F-117 Stealth Cam": 3,
    "TSP Magic Stick 3 Cam": 3,
    "TSP Bald Eagle Cathedral Stroker Twin-Turbo Cam": 3,
    "TSP Torquer V4 Cam": 3,
    "TSP Magic Stick 4 Cam": 4,
    "TSP Tsunami Cam": 4,
    "TSP Cathedral 3/4 Race Cam": 4,
    "TSP Dumpster Fire Cam": 4,
    "TSP Bald Eagle LS1/LS2 Boost Cam": 3,
    "TSP B.F.D. 5.7L/6.0L Cam": 3,
    "TSP Bald Eagle LS1/LS2 N/A Cam": 4,
    "TSP Torquer V2 Cam": 3,
    "SDPC LS6 Power Max Plus Cam (SDR51902)": 2,
    "BTR LS3 Stage 5 V2": 4,
    "BTR LS3 Hot Rod Cam": 3,
    "BTR LS3 Red Hot Cam": 4,
    "Chevrolet Performance LS3 Cam (12623063)": 1,
    "GPI SS3 LS3 Cam": 3,
    "GPI SS4 No-Cut LS3 Cam": 4,
    "GPI L99 VVT SS3 Cam": 3,
    "TSP LS3 Stroker Turbo 1200 Cam": 3,
    "TSP LS3 Stroker Turbo 2000 Cam": 4,
    "TSP LS3 PDS Stroker Cam": 3,
    "TSP NSR 6.2L Chopacabra Cam": 1,
    "TSP Bald Eagle LS3 N/A Cam": 4,
    "TSP Bald Eagle LS3 Boost Cam": 3,
    "TSP B.F.D. LS3 Cam": 3,
    "TSP B.F.D. LS3 Stroker Cam": 4,
    "TSP 6.2L Chopacabra Cam": 1,
    "TSP LS3 3/4 Race Cam": 4,
    "TSP LS3 Stroker Centrifugal Cam": 3,
    "TSP Honey Badger LS3 Cam": 4,
    "BTR LS PDS Red Hot Cam": 4,
    "Chevrolet Performance LS9 Cam (12638427)": 1,
    "TSP LS3 PDS Cam": 3,
    "TSP B.F.D. LS7 Cam": 3,
    "TSP Trailer Park Torpedo LS7 Cam": 4,
    "TSP TX Giant LS7 Stroker Cam": 4,
    "BTR Gen V 220 Cam with VVT Limiter": 2,
    "BTR Gen V 225 Cam with VVT Limiter": 2,
    "BTR Gen V 230 Cam with VVT Limiter": 3,
    "BTR Gen V 6.2L L86/LT1 DOD Conversion Cam": 1,
    "TSP Bald Eagle LT1 Stroker Boost Cam": 3,
    "TSP EL-C7 3-Bolt Cam": 3,
    "TSP LT1/LT4 V2 Turbo Cam": 3,
    "TSP EL-C7 V2 Cam": 3,
    "TSP LTx 3-Bolt Blower Cam": 3,
    "TSP LT1/LT4 V2 Supercharger Cam": 3,
    "TSP F-117 LT Cam": 3,
    "TSP LTx WIKD Supercharged Stroker Cam": 4,
    "TSP LTx WIKD Supercharged Stroker 3-Bolt Cam": 4,
    "BTR Gen V 5.3L Truck Norris Cam": 1,
    "TSP L83 V2 Turbo Cam": 3,
    "TSP L83 V2 Supercharger Cam": 3,
    "TSP L83 3-Bolt Turbo Cam": 3,
    "TSP L83 3-Bolt Blower Cam": 3,
    "TSP Gen V Chopacabra Truck Cam": 1,
    "TSP B.F.D. L83 Cam": 3,
    "BTR Gen V L8T Torque Cam with VVT Limiter": 1,
    "Chevrolet Performance L8T Non-DOD Cam (12742436)": 1,
    "Genuine GM LV1 Non-AFM Cam (12721599)": 1,
    "BTR 6.4 HEMI VVT 224": 4,
    "BTR 6.4 HEMI VVT 228": 4,
    "TSP B.F.D. Chop Monster 5.7L HEMI": 3,
    "TSP Warthog 5.7L HEMI 219/232": 3,
    "TSP Non-VVT HEMI Blower Cam": 3,
    "TSP Non-VVT HEMI Turbo Cam": 3,
    "TSP 6.4L HEMI Turbo Cam": 3,
    "COMP Thumpr NSR 214/233 (201-700-17)": 2,
    "COMP XFI 218/226 (201-424-17)": 2,
    "COMP XFI 222/230 (201-426-17)": 2,
    "COMP XFI 226/234 (201-428-17)": 3,
    "COMP Thumpr NSR 214/233 (112-700-11)": 2,
    "COMP Tri-Power Xtreme 194/206 (112-525-11)": 1,
    "COMP Tri-Power Xtreme 202/212 (112-530-11)": 1,
    "COMP Tri-Power Xtreme 210/218 (112-535-11)": 1,
    "COMP XFI 208/212 (112-500-11)": 1,
    "COMP XFI 216/220 (112-501-11)": 1,
    "COMP XFI 224/228 (112-502-11)": 2,
    "SDPC El Choppo 215/221 (SDRHElChoppo)": 2,
    "SDPC Grizzly Tow Power 222/228 (SDRH222228)": 2,
    "SDPC Reaper Hellcat 223/241 (SDRH223241)": 3,
    "MMX 5.7 VVT No-Tune MDS (MM-NTR-NSR-MDS)": 1,
    "MMX 5.7 VVT No-Tune Non-MDS (MM-NTR-NSR-NONMDS)": 1,
    "MMX 5.7 VVT CHOPSTIX (MM-NA5.7CHOPSTIX)": 2,
    "MMX 5.7 VVT MAXEFFORT (MMX-57-MAXEFFORT)": 4,
    "MMX 5.7 VVT N/A Lope (MMP-214-224HPT+)": 2,
    "MMX 5.7 VVT N/A NSR (MM-NSR-5.7-2)": 1,
    "MMX 5.7 VVT Supercharged V2.0 (MM-5.7-SC-V2)": 3,
    "MMX 6.1 N/A Performance (MMP-BG6.1-LP)": 3,
    "MMX 6.4 RAM No-Tune Non-MDS (MM-BGE6.4NONMDS)": 1,
    "MMX 6.4 RAM No-Tune MDS (MM-BGE6.4MDS)": 1,
    "MMX 6.2/6.4 High-RPM Blower (MM-426-1500-3.8)": 4,
    "MMX 6.2/6.4 PD Twin-Screw Blower (MM-411-TSB)": 3,
    "MMX 6.4 HI-RAM MAX EFFORT (MMX-HIRAM-392)": 4,
    "MMX 6.4 CHOPSTIX NSR (MM-NSR-CHOPSTIX)": 2,
    "MMX 6.4 MAX EFFORT N/A (MMP-ME-NA)": 4,
    "MMX 6.4 MAX EFFORT SC-CENT (MM-SC6.4ME-CENT)": 4,
    "MMX 6.4 MAX EFFORT SC-PD (MM-SC6.4ME-PD)": 4,
    "MMX 6.4 MAX EFFORT V2 N/A (MMX-MAX-V2)": 4,
    "MMX 6.4 N/A NSR (MMP-NSR-STG3-NA)": 1,
    "MMX 6.4 N/A NSR WK2 Megan (MMP-NSR-MEGAN)": 1,
    "MMX 6.4 SC NSR (MMP-NSR-STG3-SC)": 1,
    "MMX 6.4 BGE Towing (MMP-BGE-NA)": 2,
    "MMX Hellcat MAX EFFORT (MM-HC-ME)": 4,
    "MMX Hellcat/Trackhawk NSR (MMP-NSR-HC1+)": 1
  },
  // Truck Norris and Chopacabra pricing is included in Base Tune and Custom
  // Remote Tune pricing. HEMI-specific aliases stay explicit here, while the
  // shared cam resolver also treats every Truck Norris / Chopacabra / NSR
  // label as included before evaluating any stage-based upgrade.
  camContextTierOverrides: {
    "hemi:BTR Truck Norris": 1,
    "hemi:BTR Truck Norris NSR": 1,
    "hemi:Texas Speed Chopacabra HEMI": 1,
    "hemi:Texas Speed NSR Chopacabra": 1,
    "hemi:TSP Chopacabra 5.7L HEMI": 1
  }
};
